// JWT 점진 채택: 참여자·의뢰기업 두 흐름 모두 access 토큰을 카멜 'accessToken' 단일 키로 저장/조회한다.
// (과거엔 의뢰기업 흐름이 Login.vue 의 for..in 소문자화로 'accesstoken' 에 저장돼 라우트별로 키를
//  갈라 읽었다. 단일 키로 통일하면서 그 분기는 불필요해졌고, fallback 이 'request' 를 'contractor' 와
//  비교하던 잠복 버그도 함께 사라진다. 호출부 호환을 위해 함수는 유지하되 항상 'accessToken' 을 반환한다
//  — 잔여 소문자 쓰기 제거(CONTRACT) 후 이 shim 도 제거 예정.)
export default function getTokenByRouteMeta () {
    return 'accessToken';
}
